import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/over-ons', label: 'Over ons' },
    { path: '/ons-model', label: 'Ons model' },
    { path: '/diensten', label: 'Diensten' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm shadow-sm'
    }`}>
      <div className="max-w-6xl mx-auto px-5 flex justify-between items-center h-20">
        <Link to="/" className="flex items-center">
          <img src="/logo.webp" alt="PUUR Psychiatrie" className="h-12" />
        </Link>

        {/* Mobile menu button */}
        <button
          className="md:hidden flex flex-col justify-center gap-1.5 w-8 h-8"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Menu"
        >
          <span className={`block w-full h-0.5 bg-gray-800 transition-all ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-full h-0.5 bg-gray-800 transition-all ${isMenuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-full h-0.5 bg-gray-800 transition-all ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>

        {/* Desktop navigation */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`font-medium transition-colors relative ${
                  isActive(link.path)
                    ? 'text-[#2d5e5e]'
                    : 'text-gray-700 hover:text-[#2d5e5e]'
                }`}
              >
                {link.label}
                {isActive(link.path) && (
                  <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-[#a4cc3a]" />
                )}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/offerte"
              className="bg-[#a4cc3a] text-[#1f4a4a] px-5 py-2.5 rounded-lg font-semibold hover:bg-[#8ab32e] transition-all"
            >
              Offerte aanvragen
            </Link>
          </li>
        </ul>

        {/* Mobile navigation */}
        <ul className={`md:hidden absolute top-20 left-0 right-0 bg-white shadow-lg flex flex-col p-6 gap-4 transition-all duration-300 ${
          isMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'
        }`}>
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block font-medium ${
                  isActive(link.path) ? 'text-[#2d5e5e]' : 'text-gray-700'
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <Link
              to="/offerte"
              onClick={() => setIsMenuOpen(false)}
              className="block bg-[#a4cc3a] text-[#1f4a4a] px-5 py-2.5 rounded-lg font-semibold text-center"
            >
              Offerte aanvragen
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
